import React from 'react'
import _ from 'lodash'
import { Select_s } from "styles/input-styles"

type DetailedOption = {
  label: string
  value: any
}

type Option = string | DetailedOption

const isDetailedOption = (opt: Option): opt is DetailedOption => {
  return (opt as DetailedOption).label !== undefined
}

type DropdownInterface = {
  attrs?: Function
  className?:string
  disabled?:boolean
  disabledText?: string
  id?:string
  field?:string
  filter?: boolean
  filterPlaceholder?: string
  value:any
  options:Array<string>|Array<{label: string, value: any}>
  persist:Function
}

const DropdownInput = (props: DropdownInterface) => {
  const options =
    _.isNil(_.get(props, "options")) || _.get(props, "options.length") === 0
    ? []
    : isDetailedOption(_.get(props, "options[0]"))
      ? props.options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)
      : props.options.map((option) => <option key={option} value={option}>{option}</option>)

  const attrs = (props.attrs && !props.disabled && props.attrs(props.field)) || {}

  return (
    <span {...attrs}>
      <Select_s
        className={props.className}
        disabled={props.disabled || false}
        id={props.id}
        value={(props.disabled && props.disabledText) ? null : props.value}
        onChange={ (e) => {
          let val = _.isObject(_.get(props.options, "[0]")) ?
            _.get(_.find(props.options, x => x.value == (e.value||e.target.value)), 'value')
            :
            (e.value||e.target.value)
          props.persist(props.field, val)
        }}
        placeholder={props.disabledText || ''}>
          {(!props.value || props.disabled) && <option value="" disabled selected></option>}
          {options}
        </Select_s>
    </span>
  )
}

export default DropdownInput
